export const getColorSlug = function (val: string) {
  const url = val.split(" ").join("-").toLowerCase();
  return url;
};
